import React from 'react';
import clsx from 'clsx';
import { useToggleRefinement } from 'react-instantsearch';
import { RefinementProps } from './RefinementProps';
import { RefinementDropdown } from './RefinementDropdown';
import { Button } from '~/shared/components';
import Flex from '~/shared/components/Flex';
import Checkmark from '~/icons/checkmark.svg';
import styles from '~/features/productList/components/RefinementListRow/RefinementListRow.module.scss';
import { Facets } from '~/services/instantsearch';
import { useDrawerFilterTracking } from '~/features/productList/hooks/useDrawerFilterTracking';

export type RefinementToggleProps = RefinementProps;

export const RefinementToggle = ({ attribute, label, isVisible = true }: RefinementToggleProps) => {
    const { trackFilter } = useDrawerFilterTracking();
    const { refine, value } = useToggleRefinement({
        attribute,
        on:
            attribute === Facets.SOLE_REPRESENTATION || attribute === Facets.IS_NEW
                ? 'true'
                : 'True',
    });

    const handleRefine = () => {
        if (refine) {
            trackFilter(attribute, label, { isRefined: value.isRefined });

            refine(value);
        }
    };

    if (!isVisible) return null;

    return (
        <RefinementDropdown label={label} count={Number(value.isRefined)}>
            <Flex column>
                <Flex grow className={styles.dropdownItemContainer}>
                    <Button
                        className={styles.dropdownItemButton}
                        fullWidth
                        variant="plain"
                        onClick={handleRefine}
                        tabIndex={-1}
                    >
                        <Flex grow alignItems="center" className={styles.dropdownItemText}>
                            <Flex className={styles.dropdownTextWrapper}>
                                <span
                                    className={clsx(styles.checkmarkContainer, {
                                        [styles.isRefined]: value.isRefined,
                                    })}
                                    role="checkbox"
                                    aria-label={`${label}, ${value.count} produkter`}
                                    aria-checked={value.isRefined}
                                    tabIndex={0}
                                    onKeyDown={(event) => {
                                        if (event.key !== ' ' && event.key !== 'Enter') return;
                                        event.preventDefault();
                                        handleRefine();
                                    }}
                                >
                                    {value.isRefined && <Checkmark className={styles.checkmark} />}
                                </span>
                                {label}
                            </Flex>

                            <span className={styles.dropdownValueWrapper}>
                                {value.onFacetValue.count ? value.onFacetValue.count : ''}
                            </span>
                        </Flex>
                    </Button>
                </Flex>
            </Flex>
        </RefinementDropdown>
    );
};
